/**
 * Validation states a block can be in when a contract is checked for completeness.
 */
export enum BlockError {
  BlockEmpty = 'block-empty',
  DatapointEmpty = 'datapoint-empty',
  VariationNotSelected = 'variation-not-selected',
  UnresolvedComments = 'unresolved-comments',
}
